<template>
  <div class="pa-2">
    <v-btn @click="SignIn">login</v-btn>
  </div>
</template>

<script>
// import { PublicClientApplication } from "@azure/msal-browser";
import { mapGetters, mapState } from "vuex";
export default {
  name: "authAzure",
  computed: {
    ...mapState({
      env: (state) => state.env,
      res: (state) => state.azure.responseAzure,
    }),
    ...mapGetters({
      config: "azure/msal",
    }),
  },
  data() {
    return {
      msal: {},
    };
  },
  created() {},
  mounted() {
    this.$store.dispatch("azure/acquireToken");
  },
  methods: {
    SignIn() {
      this.$store.dispatch("azure/SignIn");
    },
  },
};
</script>

<style>
</style>